import React, { useState } from "react";
import API from "../api/Api";
import { useParams, useNavigate } from "react-router-dom";
import "./project_list_css/CsrProjectsHeader.css";

const ShowInterest = () => {
  const { project_id } = useParams();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const user_id = user?.user_id;

  const [interestType, setInterestType] = useState("");
  const [proposal, setProposal] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ===== BASIC VALIDATION =====
    if (!user_id) {
      alert("Please login or signup to continue");
      navigate("/login");
      return;
    }

    if (!interestType) {
      alert("Please select interest type");
      return;
    }

    if (!proposal) {
      alert("Please upload proposal document");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("user_id", user_id);          
      formData.append("project_id", project_id);
      formData.append("interest_type", interestType);
      formData.append("proposal_doc", proposal);
console.log("Form Data:", {
  user_id,
  project_id,
  interest_type: interestType,
  proposal_doc: proposal.name
});
      const res = await API.post("/show_intrest", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (res.data.success) {
        alert("Interest submitted successfully");
        navigate("/projects");
      }

    } catch (err) {
      alert(
        err.response?.data?.message || "Failed to submit interest"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-md-8">

          <div className="card shadow-lg border-0 rounded-4">
            <div className="card-body p-5">

              {/* ===== HEADER ===== */}
              <div className="text-center mb-4">
                <i className="fa-solid fa-handshake-angle interest-icon"></i>
                <h4 className="fw-bold mt-2">Show Interest</h4>
                <p className="text-muted small">
                  Submit your proposal to participate in this CSR project
                </p>
              </div>

              <form onSubmit={handleSubmit}>

                {/* ===== INTEREST TYPE ===== */}
                <label className="form-label fw-semibold">
                  Select Interest Type
                </label>

                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <div
                      className={`interest-card ${
                        interestType === "executor" ? "active" : ""
                      }`}
                      onClick={() => setInterestType("executor")}
                    >
                      <i className="fa-solid fa-users-gear"></i>
                      <h6>Executor</h6>
                      <p>Implement the project on ground</p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div
                      className={`interest-card ${
                        interestType === "funder" ? "active" : ""
                      }`}
                      onClick={() => setInterestType("funder")}
                    >
                      <i className="fa-solid fa-coins"></i>
                      <h6>Funder</h6>
                      <p>Provide financial support</p>
                    </div>
                  </div>
                </div>

                {/* ===== PROPOSAL DOC ===== */}
                <label className="form-label fw-semibold">
                  Upload Proposal Document
                </label>

                <div className="upload-box mb-4">
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => setProposal(e.target.files[0])}
                  />
                  <i className="fa-solid fa-file-arrow-up"></i>
                  <p>
                    Upload PDF / DOC <br />
                    <small>(Max 10MB)</small>
                  </p>
                </div>

                {/* ===== SUBMIT ===== */}
                <button
                  className="btn btn-primary w-100 py-2 fw-semibold"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : (
                    <>
                      <i className="fa-solid fa-paper-plane me-2"></i>
                      Submit Interest
                    </>
                  )}
                </button>

              </form>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ShowInterest;
